var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.tags),function(tag){return _c('button',{key:tag.value,staticClass:"filterItem",on:{"click":function($event){return _vm.clearTag(tag)}}},[_vm._v(" "+_vm._s(tag.value.getFullYear())+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }